// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { camera16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-camera': IconCamera;
    }
}

/**
 * The icon component for the 'camera' icon
 */
export class IconCamera extends IconSvg {
    public constructor() {
        super(camera16X16);
    }
}

registerIconSvg('icon-camera', IconCamera);
export const iconCameraTag = 'nimble-icon-camera';
